export const setNewAddition = (restaurants) => ({
    type: 'SET_NEWADDITION',
    restaurants
});